/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { ActionButton } from '@blend/enterprise-components';

import { PageHeader } from 'blb-components/GrommetComponents/PageHeader';
import { InviteNotaryModal } from 'blb-components/AuthenticatedApp/RON/InviteNotaryModal';

export const NotariesPageHeader: React.FC<{}> = ({}) => {
  const [isInviteNotaryModalOpen, setInviteNotaryModalOpen] = useState<boolean>(false);
  const buttons = (
    <ActionButton
      id="it-notariesPageHeader-inviteNewNotary-btn"
      label="Invite new notary"
      onClick={() => {
        setInviteNotaryModalOpen(true);
      }}
      theme="primary"
    />
  );

  return (
    <div id="it-header">
      <PageHeader actions={buttons} title="Pipeline" />
      {isInviteNotaryModalOpen && (
        <InviteNotaryModal handleClose={() => setInviteNotaryModalOpen(false)} isOpen={true} />
      )}
    </div>
  );
};
